<template>
  <div>
    <AqiMeasurement :deviceId="id" ref="aqiMeasurement" />
    <PopoverMeasurements
      :deviceId="id"
      :permissions="permissions"
      :sensorReadings="sensorReadings"
    />
    <WaitingInitialData className="standard-card " v-if="isWaitingInitialData" />
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
// Content components
import AqiMeasurement from './measurements/aqiMeasurement/AQIMeasurement.vue'
import PopoverMeasurements from './measurements/popoverMeasurements.vue'
import WaitingInitialData from '@/components/widgets/currentReadings/content/WaitingInitialData.vue'
import { DEVICE_UPDATE_INTERVAL_MS } from '@/services/device-metadata'
import { NAMESPACES } from '@/store/types'
import { DEVICE_GETTERS } from '@/store/devices'
import type { GetterByDeviceId } from '@/components/devicePopover/types'
import type { SensorReadings } from '@/services/device-service/devices'

export default defineComponent({
  name: 'PopoverMainContent',
  components: {
    AqiMeasurement,
    PopoverMeasurements,
    WaitingInitialData
  },
  props: {
    deviceId: {
      type: String,
      default: ''
    },
    permissions: {
      type: Array as PropType<string[]>,
      default: (): string[] => []
    },
    isWaitingInitialData: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadDataInterval: null as NodeJS.Timeout | null
    }
  },
  computed: {
    id(): string {
      return this.deviceId || ''
    },
    sensorReadings(): SensorReadings {
      const getter = this.$store.getters[
        `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_SENSOR_READINGS_BY_DEVICE_ID}`
      ] as GetterByDeviceId<SensorReadings>
      return getter(this.id)
    }
  },
  methods: {
    // This is used by the parent component refresh
    refresh(): void {
      const aqiRef = this.$refs.aqiMeasurement as InstanceType<typeof AqiMeasurement> | undefined
      aqiRef?.refresh()
    },
    // We maintain an interval to refresh the data once per minute because the AQI Measurement
    // averages and percent changed are not covered by data streams or the summary interval
    startLoadDataInterval(): void {
      this.refresh()
      if (this.loadDataInterval === null) {
        this.loadDataInterval = setInterval(this.refresh, DEVICE_UPDATE_INTERVAL_MS)
      }
    },
    stopLoadDataInterval(): void {
      if (this.loadDataInterval !== null) {
        clearInterval(this.loadDataInterval)
        this.loadDataInterval = null
      }
    }
  },
  mounted(): void {
    this.startLoadDataInterval()
  },
  unmounted(): void {
    this.stopLoadDataInterval()
  }
})
</script>
